import React, { useState, useCallback, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import useBreakpoint from '../useBreakpoint';

export default function MainLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isDesktop, isWide } = useBreakpoint();

  /* Auto-collapse sidebar on laptop-size screens */
  useEffect(() => {
    if (!isWide && isDesktop) setCollapsed(true);
  }, [isWide, isDesktop]);

  /* Close mobile sidebar when switching to desktop */
  useEffect(() => {
    if (isDesktop) setMobileOpen(false);
  }, [isDesktop]);

  const toggle = useCallback(() => {
    if (!isDesktop) {
      setMobileOpen(p => !p);
    } else {
      setCollapsed(p => !p);
    }
  }, [isDesktop]);

  const closeMobile = useCallback(() => setMobileOpen(false), []);

  return (
    <div style={{ fontFamily: "'Public Sans', sans-serif", height: '100vh', overflow: 'hidden' }}>
      {/* Sidebar overlay for tablet / mobile */}
      <div
        className={`sidebar-overlay${mobileOpen ? ' visible' : ''}`}
        onClick={closeMobile}
      />
      <Sidebar collapsed={isDesktop ? collapsed : false} mobileOpen={mobileOpen} />
      <Header collapsed={isDesktop ? collapsed : false} onToggle={toggle} />
      <main className={`main-content${isDesktop && collapsed ? ' expanded' : ''}`}>
        <Outlet />
      </main>
    </div>
  );
}
